module.exports = require("compare-versions");